import { useQuery } from '@tanstack/react-query';

import BackendService from '../services/backendService';

function useSSRGeneratorNew(generatorId: string) {
  const { data: elasticData, isError: elasticIsError } = useQuery({
    queryKey: ['generator-retrieve', generatorId],
    queryFn: () => BackendService.instance.generators.retrieve(generatorId),
    staleTime: 1000 * 60 * 5
  });
  return {
    generator: elasticData,
    isError: elasticIsError,
  };
}

export default useSSRGeneratorNew;
